import React, { ReactNode } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { ReactComponent as Logo } from 'assets/logo.svg';
import NavLink from 'components/PrimaryNav/NavLink';
import { BsChevronLeft } from 'react-icons/bs';
import { BackgroundImage } from 'components';
import LoginBgImage from 'assets/login-bg.svg';

interface Props {
  children?: ReactNode;
  backPath?: string;
  showLogo?: boolean;
  showBackgroundImage?: boolean;
  centerContent?: boolean;
}

const BasicLayout: React.FC<Props> = ({
  children,
  backPath,
  showBackgroundImage,
  showLogo,
  centerContent,
}: Props) => {
  return (
    <>
      {showBackgroundImage && <BackgroundImage image={LoginBgImage} />}
      {showLogo && (
        <Box
          width="180px"
          position={['relative', 'fixed']}
          margin="0 auto"
          mb={6}
          right={backPath ? ['unset', 8] : 'unset'}
          left={backPath ? 'unset' : ['unset', 8]}
          top={5}
        >
          <Logo width="100%" />
        </Box>
      )}
      {backPath && (
        <NavLink
          icon={BsChevronLeft}
          label="Go back"
          to={backPath}
          hideLabel
          position="fixed"
          width="100px"
          top={1}
          left={1}
        />
      )}
      <Flex
        minHeight={backPath ? "calc(100vh - 72px)" : "100vh"}
        height="-webkit-fit-available"
        justifyContent="center"
        alignItems="center"
      >
        {children}
      </Flex>
    </>
  );
};

export default BasicLayout;
